import React from 'react'

const Manual_configurar_niveles_lealtad = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configurar niveles de lealtad
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Configura distintos niveles de lealtad para tus clientes dentro del sistema Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configurar_niveles_de_lealtad__yVIhg46KRzSgzvHKAQd0QA?as=scrollable"
          className="scribe-iframe-general-99"
          width="100%"
          height="5800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_configurar_niveles_lealtad
